<template>
  <div id="app">
    <b-navbar toggleable="lg" type="dark" variant="primary" class="fixed-top" v-show="$route.name !== 'login' && $route.name !== 'register' && $route.name !== 'password_email' && $route.name !== 'password_reset'">
      <button @click="showCollapse = !showCollapse" :class="showCollapse ? 'collapsed' : null" aria-controls="nav_collapse" :aria-expanded="showCollapse ? 'true' : 'false'" v-if="isAuthenticated" variant="none" class="navbar-toggler">
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <b-navbar-brand class="p-0" :to="{ name: 'new' }"><img :src="$store.getters.universe.logo" :alt="siteName" style="height: 100%; max-height: 50px; width: 100%; max-width: 150px;"></b-navbar-brand>
      <b-collapse is-nav v-model="showCollapse" id="nav_collapse" v-if="isAuthenticated">
        <b-navbar-nav v-if="isAuthenticated">
          <b-nav-item :to="{ name: 'new' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
            <translate>New Shipping</translate>
          </b-nav-item>
          <b-nav-item :to="{ name: 'bulk-import' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false" v-if="!isSelfService">
            <translate>Bulk Import</translate>
          </b-nav-item>
          <b-nav-item :to="{ name: 'activity' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
            <translate>Activity</translate>
          </b-nav-item>
          <b-nav-item-dropdown offset="55" :text="$gettext('Shippings')" class="in-menu principal">
            <div class="arrow-not"></div>
            <b-dropdown-item :to="{ name: 'toreview' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>To be reviewed</translate>
            </b-dropdown-item>
            <b-dropdown-item v-if="hasCompany && !isSelfService" :to="{ name: 'drafts' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Received by the system</translate>
            </b-dropdown-item>
            <b-dropdown-item v-if="hasCompany" :to="{ name: 'ready' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Ready to be scheduled</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'manifests' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false" v-if="!isSelfService">
              <translate translate-context="Top Menu">Ongoing Manifests</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'ongoing' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Ongoing</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'incidences' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>On incidence</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'history' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>History</translate>
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item :to="{ name: 'search' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
            <translate>Search</translate>
          </b-nav-item>
          <b-nav-item v-if="!isSelfService" v-show="hasCompany && hasMeliV2Integration" :to="{ name: 'mercadolibre-v2' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
            <translate>Mercado Libre v2</translate>
          </b-nav-item>
          <b-nav-item size="sm" variant="success" v-b-modal.modalTransactionsHistory v-if="isCompanyAdmin">
            <span style="display: inline-block; width: 26px; height: 26px; font-size: 14px; line-height: 23px; text-align: center; border: 2px solid #fff; border-radius: 30px;"><translate>$</translate></span>
          </b-nav-item>
          <li class="nav-item mt-1 mx-3" style="font-size: .7rem" v-if="!isSelfService">
            <widget-cut-time classes="text-white" />
          </li>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto" v-if="isAuthenticated">
          <b-nav-item-dropdown right>
            <div class="arrow"></div>
            <template slot="button-content">
              <b-img rounded="circle" :src="this.$store.getters.profile.profile_picture" width="32" height="32" blank-color="#777" alt="img" class="" v-if="$store.getters.profile && this.$store.getters.profile.profile_picture" />
              <b-img rounded="circle" src="https://www.gravatar.com/avatar/default?s=100&r=pg&d=mm" width="32" height="32" blank-color="#777" alt="img" class="" v-else />
            </template>
            <b-dropdown-header>
              {{$store.getters.profile ? $store.getters.profile.name : ''}}<br>
              <small style="text-transform: uppercase;" v-if="$store.getters.profile && $store.getters.profile.company">{{$store.getters.profile.company.name}}</small>
            </b-dropdown-header>
            <hr class="my-2" v-if="env === 'local' || env === 'development'">
            <b-dropdown-header v-if="env === 'local' || env === 'development'">Language Test</b-dropdown-header>
            <select name="language" v-model="$language.current" style="background: #fff; border: 0;" class="form-csontrol col-sm-12" v-if="env === 'local' || env === 'development'">
              <option v-for="(language, key) in $language.available" :value="key">{{ language }}</option>
            </select>
            <hr class="my-2">
            <b-dropdown-item :to="{ name: 'profile-edit' }">
              <font-awesome-icon icon="user" size="1x" />&nbsp;&nbsp;<translate>Profile</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'company-profile' }" v-show="isCompanyAdmin">
              <font-awesome-icon icon="cog" size="1x" />&nbsp;&nbsp;<translate>Company Area</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'company-integrations' }" v-show="!isCompanyAdmin && !isSelfService">
              <font-awesome-icon icon="cog" size="1x" />&nbsp;&nbsp;<translate>Integrations</translate>
            </b-dropdown-item>
            <b-dropdown-item href="#" @click.prevent="logout()">
              <font-awesome-icon icon="sign-out-alt" size="1x" />&nbsp;&nbsp;<translate>Sign out</translate>
            </b-dropdown-item>
            <hr class="my-2" v-if="$country && ($country.clients_terms || $country.privacy_policy)">
            <b-dropdown-item v-if="$country && $country.clients_terms" :href="$country.clients_terms.indexOf('http') === 0 ? $country.clients_terms : `https://moova-terms.s3.amazonaws.com/${$eid}/${window.country.toLowerCase()}/${$country.clients_terms}.html`" class="small" target="_blank">
              <translate>Terms and Conditions</translate>
            </b-dropdown-item>
            <b-dropdown-item v-if="$country && $country.privacy_policy" :href="$country.privacy_policy.indexOf('http') === 0 ? $country.privacy_policy : `https://moova-terms.s3.amazonaws.com/${$eid}/${window.country.toLowerCase()}/${$country.privacy_policy}.html`" class="small" target="_blank">
              <translate>Privacy Policy</translate>
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
      <b-navbar-nav class="ml-auto" v-if="isAuthenticated && $store.getters.universe.helpUrl">
        <b-nav-item :href="$store.getters.universe.helpUrl" target="_blank" class="no-border">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="34" viewBox="0 0 28 34">
            <g fill="none" fill-rule="evenodd">
              <circle cx="14" cy="17" r="12" stroke="#ffffff" stroke-width="2" />
              <path fill="#ffffff" d="M13.48 26c-.457 0-.856-.148-1.196-.443-.341-.296-.511-.71-.511-1.241 0-.472.164-.868.494-1.19.33-.322.733-.483 1.212-.483.472 0 .869.16 1.19.483.322.322.484.718.484 1.19 0 .524-.169.936-.506 1.235-.337.3-.726.449-1.168.449M8 13.694c0-.712.228-1.432.685-2.162.456-.73 1.123-1.334 1.999-1.813.875-.48 1.897-.719 3.065-.719 1.085 0 2.044.2 2.874.6.831.401 1.473.946 1.926 1.635.453.688.68 1.437.68 2.245 0 .637-.13 1.194-.388 1.673a5.125 5.125 0 0 1-.92 1.241 67.2 67.2 0 0 1-1.915 1.757 7.792 7.792 0 0 0-.612.612 2.483 2.483 0 0 0-.343.483 2.37 2.37 0 0 0-.174.438c-.04.146-.103.403-.185.77-.142.778-.588 1.167-1.336 1.167-.39 0-.717-.127-.983-.382-.265-.254-.398-.632-.398-1.134 0-.629.097-1.173.292-1.634.194-.46.453-.864.775-1.212a17.81 17.81 0 0 1 1.302-1.241c.479-.42.825-.735 1.039-.949a3.22 3.22 0 0 0 .539-.713c.146-.262.219-.546.219-.853 0-.6-.223-1.104-.668-1.516-.446-.412-1.02-.618-1.724-.618-.824 0-1.43.208-1.82.624-.388.415-.718 1.027-.987 1.835-.255.846-.738 1.27-1.449 1.27-.419 0-.773-.148-1.06-.444-.29-.296-.433-.616-.433-.96" />
              <g stroke="#4A4A4A">
                <path d="M-575.5-37.5h1290v148h-1290z" />
              </g>
            </g>
          </svg>
        </b-nav-item>
      </b-navbar-nav>
    </b-navbar>
    <div class="main-container">
      <button v-b-modal.modalTutorials class="btn-tutorials bg-secondary text-white" v-if="$appConfig.tutorials[$language.current.split('_')[0]][$route.name]">
        <font-awesome-icon icon="video" size="1x" />
        <translate>View the video tutorial about this screen</translate>
      </button>
      <b-modal size="xl" id="modalTutorials" ref="modalTutorials" hide-footer hide-header >
        <lazy-youtube max-width="100%" thumbnail-quality="maxres" :src="$appConfig.tutorials[$language.current.split('_')[0]][$route.name]" />
      </b-modal>
      <div id="cant-operate" v-if="(!isCompanyConfirmed || !hasCompany || (isCompanyAdmin && !hasMarketingSettings && !isSelfService)) && $route.name !== 'login' && $route.name !== 'register' && $route.name !== 'password_email' && $route.name !== 'password_reset' && $route.name !== 'external_shipping' && $route.name !== 'external_shipping_with_hash_hack' && $route.name !== 'external_shipping_with_hash' && $route.name !== 'external_shipping_unsubscribe_with_hash' && $route.name !== 'shopify-v2-redirect'&& $route.name !== 'shopify-redirect' && $route.name !== 'SelfServiceRedirect'">
        <div v-if="hasCompany && !isCompanyConfirmed">
          <b-container v-if="!isSelfService">
            <b-row>
              <b-col cols="12" class="text-center pt-5">
                <img :src="$store.getters.universe.logoLogin" :alt="$store.getters.universe.siteName" style="height: 100%; max-height: 50px; width: auto; max-width: 150px;">
                <h2 class="text-center pt-5" v-translate>Sorry, your company is pending for system approval</h2>
                <h3 class="text-center pt-5" v-translate>The process can take up to 48 hours</h3>
                <h4 class="text-center pt-5" v-if="$store.getters.profile && $store.getters.profile.name" v-translate="{user: $store.getters.profile.name}">Hi %{user}! You will receive an e-mail as soon as it's approved and then you will be able to freely operate</h4>
                <h4 class="text-center pt-5" v-translate>Thank you very much for your patience :)</h4>
                <h4 class="text-center pt-5" v-translate="{helpEmail: this.helpEmail}">Should you have any doubt? Write us at <a href="mailto:%{helpEmail}">%{helpEmail}</a></h4>
              </b-col>
            </b-row>
          </b-container>
          <b-container v-else>
            <b-row>
              <b-col cols="12" class="text-center pt-5">
                <img :src="$store.getters.universe.logoLogin" :alt="$store.getters.universe.siteName" style="height: 100%; max-height: 50px; width: auto; max-width: 150px;">
                <h2 class="text-center pt-5" v-translate>Sorry, you need to confirm your information before being able to operate</h2>
                <!-- <h3 class="text-center pt-5" v-translate>The process can take up to 48 hours</h3> -->
                <h4 class="text-center pt-5" v-if="$store.getters.profile && $store.getters.profile.name" v-translate="{user: $store.getters.profile.name}">Hi %{user}! You have received an e-mail with a link. Please, click the email's link to confirm your information and then you will be able to freely operate</h4>
                <h4 class="text-center pt-5" v-translate>Thank you very much 😊</h4>
                <h4 class="text-center pt-5" v-translate="{helpEmail: this.helpEmail}">Should you have any doubt? Write us at <a href="mailto:%{helpEmail}">%{helpEmail}</a></h4>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div v-if="hasCompany && isCompanyConfirmed && isCompanyAdmin && !hasMarketingSettings && !isSelfService">
          <b-container>
            <b-row>
              <b-col cols="12" class="text-center pt-5">
                <img :src="$store.getters.universe.logoLogin" :alt="$store.getters.universe.siteName" style="height: 100%; max-height: 50px; width: auto; max-width: 150px;">
                <h5 class="pt-5" v-translate>Hi!</h5>
                <p v-translate>In order to bring you an even better service, please complete the following for your Company profile, thank you!</p>
                <b-row class="justify-content-md-center">
                  <b-col cols="12" md="8" lg="6" class="text-left">
                    <h5 class="mt-4" v-translate>Industries <small class="text-danger">(required)</small></h5>
                    <b-form-text v-translate class="text-muted mb-2">Please select one or more</b-form-text >
                    <marketing-settings-form />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div v-if="isAuthenticated && !hasCompany">
          <b-container>
            <b-row align-h="center">
              <b-col cols="12" sm="10" lg="8" xl="6" class="text-center pt-5">
                <img :src="$store.getters.universe.logoLogin" :alt="$store.getters.universe.siteName" style="height: 100%; max-height: 50px; width: auto; max-width: 150px;">
                <register-form class="pt-5" />
              </b-col>
            </b-row>
          </b-container>
        </div>

      </div>
      <div id="cant-operate" v-else-if="!$frontConfig && $route.name !== 'shopify-v2-redirect' && $route.name !== 'shopify-redirect' && $route.name !== 'profile-shopify-integrations' && $route.name !== 'profile-shopify-integrations' && $route.name !== 'company-integrations' && $route.name !== 'external_shipping' && $route.name !== 'SelfServiceRedirect'">
        <b-container>
          <b-row>
            <b-col cols="12" class="text-center pt-5">
              <img :src="$store.getters.universe.logoLogin" :alt="$store.getters.universe.siteName" style="height: 100%; max-height: 50px; width: auto; max-width: 150px;">
              <h2 class="text-center pt-5">Oops! It seems you are in a country where we still don't operate :(</h2>
              <h2 class="text-center">¡Oh! Parece que estás en un país en el que todavía no operamos :(</h2>
              <h4 class="text-center pt-5">Are you browsing through a VPN/proxy? Select your country below</h4>
              <h4 class="text-center pb-3">¿Estás navegando a través de una VPN/proxy? Selecciona tu país a continuación</h4>
              <b-form-select v-model="window.country" :options="window.countries.map(x => { return {value: x.iso_code, text: x.name} })" class="col-6 col-md-4 col-lg-2" @change="setNewCountry">
                <template slot="first">
                  <option :value="null">Select/Selecciona</option>
                </template>
              </b-form-select>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <div v-else>
        <b-alert v-if="isAuthenticated && $store.getters.profile.company" variant="warning" :show="$store.getters.profile.company.has_credit === false" style="position: fixed; top: 50px; left: 50%; transform: translateX(-50%); width: 95%; max-width: 600px; z-index: 1029;">
          <translate>Your account has reached the credit limit and cannot continue operating.</translate> <b-button variant="warning" size="sm" v-translate v-b-modal.modalAddCredit>Review</b-button>
        </b-alert>
        <b-modal size="lg" id="modalAddCredit" ref="modalAddCredit" hide-footer>
          <div slot="modal-title" v-translate>Add credit</div>
          <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
          <company-credit-overlay in-modal free />
        </b-modal>
        <router-view></router-view>
      </div>
      <b-modal size="xl" id="modalTransactionsHistory" ref="modalTransactionsHistory" :hide-footer="true" @show="generatePeriods" @hide="showTransactionsPeriod = null; clearTimeoutTransactions()">
        <div slot="modal-title" v-translate>Transactions History</div>
        <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
        <div v-if="currentCompanyBalance">
          <h3><span
            v-translate="{totalTransactions: $options.filters.currency(currentCompanyBalance, $store.getters.profile.company.country_iso_code), hasCredit: $store.getters.profile.company.has_credit ? 'text-success' : 'text-danger'}"
          >Current Company Balance: <span class="%{hasCredit}">%{totalTransactions}</span></span> <b-button size="sm" variant="primary" v-b-modal.modalAddCreditForm v-if="isCompanyAdmin">
            <translate>Add credit</translate>
          </b-button></h3>
          <div v-if="shippingsAprox > 0">
            <b-form-text v-translate="{shippingsAprox: shippingsAprox}" :translate-n="shippingsAprox" translate-plural="You may create %{shippingsAprox} shippings (This is an aproximate quantity and may vary depending on the origin and destination, size or type of each shipping)">You may create %{shippingsAprox} shipping (This is an aproximate quantity and may vary depending on the origin and destination, size or type of each shipping)</b-form-text>
          </div>
          <div v-else>
            <b-form-text v-translate>You can't create new shippings until you add some credit to your Company account</b-form-text>
          </div>
          <b-modal id="modalAddCreditForm" ref="modalAddCreditForm" hide-footer>
            <div slot="modal-title" v-translate>Add credit</div>
            <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
            <add-credit-form in-modal free />
          </b-modal>
          <hr>
        </div>
        <p><strong v-translate>NOTE: All amounts displayed here DO NOT include VAT</strong></p>
        <h4>
          <translate>Select the period</translate>
          <b-form-select v-model="showTransactionsPeriod" :options="transactionsPeriods" class="w-auto">
          </b-form-select>
          <b-button size="sm" variant="primary" @click.prevent="generateTransactionsCsv()" :disabled="disableTransactionsReport" v-translate>
            Generate Transactions Report
          </b-button>
        </h4>
        <b-alert variant="success" show>
          <h2 class="my-0" v-translate="{totalTransactions: this.totalAmountDisplay}">Selected period's transactions: %{totalTransactions}</h2>
        </b-alert>
        <div v-if="transactions.length > 0">
          <b-table striped
            :items="transactions"
            :fields="transactionFields"
            responsive="lg"
            id="transactionsTable"
          >
          <template v-slot:table-colgroup="scope">
            <col
              v-for="field in scope.fields"
              :key="field.key"
              :style="{ width: field.key === 'addresses' ? '250px' : '' }"
            >
          </template>
            <template v-slot:cell(shipping_id)="data">
              <span v-if="data.value">
                <span>
                  <router-link :to="{name: 'shipping', params: {'id': data.value}}" class="preview-link" target="_blank">
                    #{{data.value | uuid }}
                  </router-link>
                </span>
              </span>
              <translate v-if="data.item.reason === 'payment'">Payment</translate>
            </template>
            <template v-slot:cell(addresses)="data" class="bg-dark">
              <div class="shipping-address" style="width: 250px" v-translate="{from: data.item.from}" v-if="data.item.from">
                From: %{from}
              </div>
              <div class="shipping-address" style="width: 250px" v-translate="{to: data.item.to}" v-if="data.item.to">
                To: %{to}
              </div>
            </template>
            <template v-slot:cell(imputation_date)="data">
              {{moment.utc(data.value).local().format('L LT')}}
            </template>
            <template v-slot:cell(reason)="data">
              <b-badge pill :variant="data.value === 'delivered' ? 'success' : (data.value === 'payment' ? 'dark' : (data.value === 'incidence' || data.value === 'credit_note' || data.value === 'debit_note' ? 'warning' : 'danger'))">
                <span v-show="data.value === 'delivered'"><translate>Delivered</translate></span>
                <span v-show="data.value === 'incidence'"><translate>Incidence</translate></span>
                <span v-show="data.value === 'returned'"><translate>Returned</translate></span>
                <span v-show="data.value === 'credit_note'"><translate>Credit Note</translate></span>
                <span v-show="data.value === 'debit_note'"><translate>Debit Note</translate></span>
                <span v-show="data.value === 'payment'"><translate>Payment</translate></span>
              </b-badge>
              <small v-if="data.item.details">{{statusReasonsStrings[data.item.details.name] || data.item.details}} {{statusReasonEvents[data.item.details.event] || data.item.details.event}}</small>
            </template>
          </b-table>
          <b-pagination
            v-if="transactionsRows > transactionsPerPage"
            v-model="transactionsCurrentPage"
            :total-rows="transactionsRows"
            :per-page="transactionsPerPage"
            aria-controls="transactionsTable"
            align="center"
          ></b-pagination>
        </div>
        <b-alert variant="info" show v-else>
          <h3 class="my-0" v-translate>There were no transactions in the selected period</h3>
        </b-alert>
      </b-modal>
    </div><!-- /#page -->
    <span id="powered-by" v-if="$store.getters.universe.showPoweredBy">Powered by <a href="https://moova.io" target="_blank">Moova</a></span>
    <simplert :useRadius="true" :useIcon="true" ref="simplert" /><!-- notifs -->
    <b-toast id="toast-front-version" variant="info" solid no-auto-hide>
      <p v-translate>There is a new version of the Dashboard, please reload all currently opened windows/tab to get the new version with the latest changes.</p>
      <p>
        <span v-translate="{currentFrontVersion: currentFrontVersion}">Current version: <em>%{currentFrontVersion}</em></span><br>
        <span v-translate="{availableFrontVersion: availableFrontVersion}">Available version: <strong>%{availableFrontVersion}</strong></span>
      </p>
    </b-toast>

    <b-toast :id="'announcement-' + announcement.id" v-for="announcement in announcements" v-if="announcements.length > 0" :key="'announcement-' + announcement.id" visible variant="warning" toaster="b-toaster-top-center" solid no-auto-hide no-close-button>
      <div v-html="$options.filters.brize(announcement.message)"></div>
      <div class="mt-3 text-center"><b-button size="sm" variant="warning" @click="dismissAnnouncement(announcement.id)" v-translate>Close</b-button></div>
    </b-toast>

    <div id="npsSidePanel"></div>
    <div id="npsSidetab"></div>

    <div v-if="env !== 'production'" id="env">{{this.env}}</div>
    <div class="d-none">
      <translate>Shippings</translate>
    </div>
  </div>
</template>
<script>
import constants from '@/common/constants'
import simplert from 'vue2-simplert'
import { mapGetters } from 'vuex'
import RegisterForm from '@/components/RegisterForm'
import MarketingSettingsForm from '@/components/MarketingSettingsForm'
import AddCreditForm from '@/components/AddCreditForm'
import WidgetCutTime from '@/components/WidgetCutTime'
import CompanyCreditOverlay from '@/components/CompanyCreditOverlay'
import { LazyYoutube } from 'vue-lazytube'

export default {
  name: 'App',
  components: {
    simplert,
    RegisterForm,
    MarketingSettingsForm,
    AddCreditForm,
    WidgetCutTime,
    CompanyCreditOverlay,
    LazyYoutube
  },
  data() {
    return {
      env: process.env.ENV_FLAG,
      showCollapse: false,
      window,
      transactions: [],
      transactionFields: [
        {
          key: 'shipping_id',
          label: this.$gettext('Shipping ID')
        },
        {
          key: 'addresses',
          label: this.$gettext('Addresses')
        },
        {
          key: 'to_contact',
          label: this.$gettext('Destination Contact')
        },
        {
          key: 'amount_display',
          label: this.$gettext('Amount')
        },
        {
          key: 'imputation_date',
          label: this.$gettext('Date')
        },
        {
          key: 'reason',
          label: this.$gettext('Reason')
        }
      ],
      transactionsPeriods: [],
      showTransactionsPeriod: null,
      totalAmountDisplay: '',
      intervalBalance: null,
      intervalTransactions: null,
      intervalTransactionsLength: 60000,
      transactionsCurrentPage: 1,
      transactionsRows: 0,
      transactionsPerPage: 25,
      currentCompanyBalance: null,
      currentFrontVersion: '',
      availableFrontVersion: '',
      updateNotice: false,
      intervalCheckFrontVersionInterval: 5 * 60 * 1000,
      intervalCheckFrontVersion: null,
      announcements: [],
      dismissed: []
    }
  },
  watch: {
    showTransactionsPeriod(val) {
      this.transactionsCurrentPage = 1
      this.transactionsRows = 0
      this.fetchTransactions(val)
    },
    transactionsCurrentPage(val) {
      this.fetchTransactions()
    }
  },
  computed: {
    disableTransactionsReport() {
      return !(this.showTransactionsPeriod &&
        (
          this.$store.getters.profile.company.account.credit_limit !== null ||
          (
            this.moment.utc().tz(this.$tz).date() !== 1 &&
            this.moment.utc().tz(this.$tz).date() !== 16
          ) ||
          (
            this.moment.utc(this.showTransactionsPeriod.to).tz(this.$tz).date() !== 1 &&
            this.moment.utc(this.showTransactionsPeriod.to).tz(this.$tz).date() !== 16
          )
        ))
    },
    ...mapGetters([
      'user'
    ])
  },
  mixins: [constants],
  created() {
    // i18n setup
    if (this.$frontConfig) {
      this.$language.current = this.$frontConfig.i18n.lang || 'en_US'
      const moment = this.$frontConfig.i18n.moment || 'en'
      this.moment.locale(moment)
      this.moment.tz.setDefault(this.$tz)
      // if (!this.$universe && this.$frontConfig.universe) {
      //   this.$universe = this.$frontConfig.universe
      // }
    } else {
      window.country = null
    }

    if (this.$eid === 1) {
      if (!this.$universe) {
        this.$universe = {
          siteName: 'Moova',
          logo: '/static/img/moova.svg',
          logoLogin: '/static/img/moova-blue.svg',
          theme: 'moova',
          helpUrl: 'http://ayuda.moova.io/',
          helpEmail: 'help@moova.io',
          salesEmail: 'comercial@moova.io',
          googleRegister: true,
          terms: 'https://moova.io/terminos-y-condiciones/',
          privacy: 'https://moova.io/politica-de-privacidad/'
        }
      }
      this.$store.dispatch('setUniverse', this.$universe)
    }

    // Dynamic favicon
    const link = document.querySelector("link[rel*='icon']") || document.createElement('link')
    link.type = 'image/png'
    link.rel = 'shortcut icon'
    link.href = '/static/img/dashboard-icon' + (process.env.NODE_ENV !== 'production' ? '-development' : '') + '.png'
    document.getElementsByTagName('head')[0].appendChild(link)
  },
  mounted() {
    this.init()
    this.checkFrontVersion()
  },
  beforeDestroy() {
    clearTimeout(this.intervalCheckFrontVersion)
    this.intervalCheckFrontVersion = null // just in case
  },
  methods: {
    checkFrontVersion() {
      clearTimeout(this.intervalCheckFrontVersion)
      this.intervalCheckFrontVersion = null // just in case
      this.$http.get('/static/version.json')
        .then(response => {
          this.availableFrontVersion = response.body.version
          if (this.currentFrontVersion === '') {
            this.currentFrontVersion = this.availableFrontVersion
          } else if (this.currentFrontVersion !== this.availableFrontVersion) {
            if (this.updateNotice === false) {
              this.$bvToast.show('toast-front-version')
              this.updateNotice = true
            }
          }
          if (this.$route.name !== 'login' && this.$route.name !== 'register' && this.$route.name !== 'password_email' && this.$route.name !== 'password_reset' && this.$route.name !== 'shopify-v2-redirect' && this.$route.name !== 'shopify-redirect' && this.$route.name !== 'SelfServiceRedirect') {
            this.checkForAnnouncements()
          }
          this.intervalCheckFrontVersion = setTimeout(function () {
            this.checkFrontVersion()
          }.bind(this), this.intervalCheckFrontVersionInterval)
        })
    },
    async checkForAnnouncements() {
      const app = this.$route.name.indexOf('external_shipping') !== -1 ? 'dashboard_external' : 'dashboard'
      this.dismissed = this.getLocalStorage('dismissedAnnouncements') || []
      await this.$http.get(this.$appConfig.api.baseUrl + 'announcements/' + app + '/country/' + window.country)
        .then(async response => {
          if (response.body.length > 0) {
            this.announcements = response.body.filter(x => this.dismissed.indexOf(x.id) === -1)
            this.announcements.forEach(element => {
              this.$bvToast.show('announcement-' + element.id)
            })
          } else {
            this.announcements = []
            this.setLocalStorage('dismissedAnnouncements', [])
          }
        })
    },
    dismissAnnouncement(id) {
      this.$bvToast.hide('announcement-' + id)
      this.dismissed.push(id)
      this.setLocalStorage('dismissedAnnouncements', [...this.dismissed])
      setTimeout(() => {
        this.announcements.splice(this.announcements.findIndex(x => x.id === id), 1)
      }, 500)
    },
    logout() {
      this.$http.post(this.$appConfig.api.baseUrl + 'logout')
        .then(() => {
          this.$store.dispatch('logout').then(() => {
            window.location.href = window.location.origin
          })
        })
    },
    setNewCountry() {
      if (window.country !== null) {
        this.$frontConfig = window.countries.find(x => x.iso_code === window.country).front_config || null
        this.$cookies.set('country', window.country, 60 * 60 * 24 * 30, null, null, (process.env.COOKIE_SECURE !== '' || false), process.env.COOKIE_SAME_SITE)
        this.$cookies.set('phonePrefix', this.$frontConfig.i18n.phonePrefix, 60 * 60 * 24 * 30, null, null, (process.env.COOKIE_SECURE !== '' || false), process.env.COOKIE_SAME_SITE)
        this.$emit('countryChanged')
      }
      window.location.reload()
    },
    setTimeoutTransactions() {
      clearTimeout(this.intervalTransactions)
      this.intervalTransactions = setTimeout(function () {
        this.updateCompanyBalance()
        this.generatePeriods()
        this.fetchTransactions()
      }.bind(this), this.intervalTransactionsLength)
    },
    clearTimeoutTransactions() {
      clearTimeout(this.intervalTransactions)
    },
    setTimeoutBalance() {
      clearTimeout(this.intervalBalance)
      this.intervalBalance = setTimeout(function () {
        this.updateCompanyBalance()
      }.bind(this), this.intervalTransactionsLength)
    },
    clearTimeoutBalance() {
      clearTimeout(this.intervalBalance)
    },
    updateCompanyBalance() {
      this.$http.get(this.$appConfig.api.baseUrl + 'users/' + this.$store.getters.profile.id)
        .then(response => {
          if (response.body.company.account.credit_limit !== null) {
            this.currentCompanyBalance = response.body.company.account.balance
            this.shippingsAprox = window.countries.find(x => x.iso_code === response.body.country_iso_code).credit_threshold > 0 ? parseInt(this.currentCompanyBalance / window.countries.find(x => x.iso_code === response.body.country_iso_code).credit_threshold) : 0
          }
        })
    },
    fetchTransactions(period = null) {
      this.updateCompanyBalance()
      if (
        this.showTransactionsPeriod &&
          (
            this.$store.getters.profile.company.account.credit_limit !== null ||
            (
              this.moment.utc().tz(this.$tz).date() !== 1 &&
              this.moment.utc().tz(this.$tz).date() !== 16
            ) ||
            (
              this.moment.utc(this.showTransactionsPeriod.to).tz(this.$tz).date() !== 1 &&
              this.moment.utc(this.showTransactionsPeriod.to).tz(this.$tz).date() !== 16
            )
          )
      ) {
        const params = {
          page: this.transactionsCurrentPage - 1,
          limit: this.transactionsPerPage,
          sort: [
            {
              key: 'imputation_date',
              direction: 'desc'
            }
          ],
          date_from: period ? period.from : this.showTransactionsPeriod.from,
          date_to: period ? period.to : this.showTransactionsPeriod.to,
          includes: [
            'courier',
            'shipping'
          ],
          filter_groups: [
            {
              filters: [
                ['relationship', 'eq', 'client']
              ]
            }
          ]
        }

        this.$http.get(this.$appConfig.api.baseUrl + 'companies/' + this.$store.getters.profile.company_id + '/transactions', { params })
          .then(response => {
            this.totalAmountDisplay = ''
            if (response.body.data.length > 0) {
              this.transactionsRows = response.body.pagination.total
              this.transactions = response.body.data.map(x => {
                x.amount = x.type === 'credit' || parseFloat(x.amount) === 0 ? parseFloat(x.amount) : -(parseFloat(x.amount))
                return {
                  shipping_id: x.shipping_id || null,
                  reason: x.reason,
                  details: x.meta ? (x.meta.reason || (x.meta.meta !== '' ? x.meta.meta : x.meta.details.reason)) : ((x.reason === 'credit_note' || x.reason === 'debit_note') && x.reference ? x.reference : null),
                  courier: x.courier ? x.courier.name : '',
                  to_contact: x.shipping ? x.shipping.to_contact : '',
                  amount: x.amount,
                  amount_display: x.type === 'credit' ? x.amount_formatted : '-' + x.amount_formatted,
                  imputation_date: x.imputation_date,
                  from: x.shipping ? x.shipping.address_from.formatted_address : null,
                  to: x.shipping ? x.shipping.address_to.formatted_address : null
                }
              })
            } else {
              this.transactions = []
            }

            const params = {
              date_from: period ? period.from : this.showTransactionsPeriod.from,
              date_to: period ? period.to : this.showTransactionsPeriod.to,
              filter_groups: [
                {
                  filters: [
                    ['relationship', 'eq', 'client']
                  ]
                }
              ]
            }
            this.$http.get(this.$appConfig.api.baseUrl + 'companies/' + this.$store.getters.profile.company_id + '/transactions/summary', { params })
              .then(response => {
                this.totalAmountDisplay = response.body.benefit_formatted
              })
            this.setTimeoutTransactions()
          })
      } else {
        this.totalAmountDisplay = this.$options.filters.currency(0, this.$store.getters.profile.company.country_iso_code)
        this.transactions = []
        this.transactionsRows = 0
        this.setTimeoutTransactions()
      }
    },
    generateTransactionsCsv(period = null) {
      if (
        this.showTransactionsPeriod &&
          (
            this.$store.getters.profile.company.account.credit_limit !== null ||
            (
              this.moment.utc().tz(this.$tz).date() !== 1 &&
              this.moment.utc().tz(this.$tz).date() !== 16
            ) ||
            (
              this.moment.utc(this.showTransactionsPeriod.to).tz(this.$tz).date() !== 1 &&
              this.moment.utc(this.showTransactionsPeriod.to).tz(this.$tz).date() !== 16
            )
          )
      ) {
        const params = {
          format: 'upload',
          sort: [
            {
              key: 'imputation_date',
              direction: 'desc'
            }
          ],
          date_from: period ? period.from : this.showTransactionsPeriod.from,
          date_to: period ? period.to : this.showTransactionsPeriod.to,
          includes: [
            'courier',
            'shipping'
          ],
          filter_groups: [
            {
              filters: [
                ['relationship', 'eq', 'client']
              ]
            }
          ]
        }
        this.$http.get(this.$appConfig.api.baseUrl + 'companies/' + this.$store.getters.profile.company_id + '/transactions', { params })
          .then(response => {
            const obj = {
              title: this.$gettext('JOB DISPATCHED'),
              message: this.$gettext('The Transactions Report is being generated, you will receive an email with a link to download it as soon as it\'s done'),
              type: 'success',
              customCloseBtnText: this.$gettext('Close')
            }
            this.$root.$children[0].$refs.simplert.openSimplert(obj)
          })
      }
    },
    // generatePeriods() {
    //   this.transactionsPeriods = []
    //   let from
    //   let to
    //   const realTodayDay = this.moment().tz(this.$tz).date()
    //   let baseDate = this.moment().utc()
    //   console.log(realTodayDay)
    //
    //   for (let period = 0; period < 2; period++) {
    //     if (baseDate.date() < 16) {
    //       from = baseDate.clone().date(1)
    //       to = period === 0 ? (realTodayDay === 1 ? from.clone() : (this.$store.getters.profile.company.account.credit_limit !== null ? this.moment().tz(this.$tz) : this.moment().tz(this.$tz).subtract(1, 'day'))) : baseDate.clone().date(15)
    //     } else {
    //       from = baseDate.clone().date(16)
    //       to = period === 0 ? (realTodayDay === 16 ? from.clone() : (this.$store.getters.profile.company.account.credit_limit !== null ? this.moment().tz(this.$tz) : this.moment().tz(this.$tz).subtract(1, 'day'))) : baseDate.clone().endOf('month')
    //     }
    //
    //     baseDate = from.clone().subtract(from.month() === 2 && from.date() <= 16 ? 13 : 15, 'day')
    //     from = from.startOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
    //     to = to.endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
    //
    //     if (period === 0 && !this.showTransactionsPeriod) {
    //       this.showTransactionsPeriod = {from: from, to: to}
    //     }
    //
    //     this.transactionsPeriods.push({value: {from: from, to: to}, text: this.moment.utc(from).local().format('L') + ' - ' + this.moment.utc(to).local().format('L') + (period === 0 ? ' ' + this.$gettext('(current)') : '')})
    //   }
    // },
    generatePeriods() {
      this.transactionsPeriods = []
      let from
      let to
      let baseDate = this.moment()
      const realTodayDay = baseDate.date()

      for (let period = 0; period < 5; period++) {
        if (baseDate.date() <= 15) {
          from = baseDate.clone().date(1)
          to = period === 0 ? (realTodayDay === 1 ? from.clone() : (this.$store.getters.profile.company.account.credit_limit !== null ? this.moment() : this.moment().subtract(1, 'day'))) : baseDate.clone().date(15) // baseDate.clone().date(15)
        } else {
          from = baseDate.clone().date(16)
          to = period === 0 ? (realTodayDay === 16 ? from.clone() : (this.$store.getters.profile.company.account.credit_limit !== null ? this.moment() : this.moment().subtract(1, 'day'))) : baseDate.clone().endOf('month') // baseDate.clone().endOf('month')
        }

        baseDate = from.clone().subtract(1, 'day')
        from = from.startOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
        to = to.endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')

        this.transactionsPeriods.push({ value: { from, to }, text: this.moment.utc(from).tz(this.$tz).format('L') + ' - ' + this.moment.utc(to).tz(this.$tz).format('L') + (period === 0 ? ' ' + this.$gettext('(current)') : '') })
      }
      if (!this.showTransactionsPeriod) {
        this.showTransactionsPeriod = this.transactionsPeriods[0].value
      }
    }
  }
}
</script>
<style lang="scss">
#app {
  margin: 0;
  min-height: 100vh;
  padding: 50px 0 0;
}

.page-header {
  height: auto !important;
}

.simplert {
  z-index: 10060 !important;
}

#env {
  position: fixed;
  top: 0;
  left: 0;
  background: #000;
  color: #fff;
  padding: 2px 5px;
  z-index: 10000
}
.in-menu .dropdown-toggle {
  line-height: 40px !important;
  text-transform: uppercase;
  font-size: 12px !important;
}
#cant-operate {
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  width: 100%;
  height: 100%;
  z-index: 1040;
  overflow-y: auto;
}

/* for T&C dropdown link height */
.navbar .dropdown-menu .small .dropdown-item {
  padding: .35rem 1.5rem;
}

/* 2FA PINcode */
div.vue-pincode-input-wrapper {
  font-size: 1.6rem;
}

input.vue-pincode-input {
  box-shadow: 0 0 15px rgba(0,0,0,.1);
  max-width: 3rem !important;
  margin: .25rem !important;
  background: #fff;
  border: 1px solid #ddd;
  transition: all .25s ease-in-out;
  &:focus {
    border: 1px solid #ccc;
    box-shadow: 0 0 5px rgba(0,0,0,.25);
  }
}
</style>
